import { useContext } from "react";
import { CommonDataContext } from "context/CommonDataContext";

export function useCityName() {
  const { airports } = useContext(CommonDataContext);

  return (stationCode: string) => {
    const airport = airports?.find((airportData: { stationCode: string }) => airportData.stationCode === stationCode);
    return airport ? airport.cityInfo.name : null;
  };
}
